module.exports = __webpack_public_path__ + "img/solution.e758b94a.png";